<template>
  <div class="cargo">
    <page-header title="Грузоперевозки с компанией Vozovoz" title-in-breadcrumbs="Грузоперевозки" />
    <div id="about" class="public-container public-container-mobile cargo-container">
      <shipping-types-list />
      <cargo-info />
      <div>
        <h2 class="vz-text-align-left">Расчет стоимости</h2>
        <vz-calculator promocode="VEZET15" />
        <p class="mt-30">Чтобы узнать стоимость и сроки доставки введите параметры груза в онлайн-калькулятор.</p>
      </div>
      <div>
        <h2 class="vz-text-align-left">Полезная информация</h2>
        <public-service-links-grid :items="usefulItems" compact text-only class="cargo-container-useful" />
      </div>
      <contacts-departments class="cargo-container-contacts">
        <template #title>
          <h2 class="vz-text-align-left">Обратная связь</h2>
        </template>
      </contacts-departments>
      <cargo-help />
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import ShippingTypesList from '~/components/public/shipping-types/shipping-types-list.vue';
import VzCalculator from '~/components/public/order/vz-calculator.vue';
import PublicServiceLinksGrid from '~/components/public/public-service-links-grid.vue';
import {PublicInfoGridItem} from '~/types/public';
import ContactsDepartments from '~/components/public/contacts/contacts-departments.vue';
import CargoHelp from '~/components/public/cargo/cargo-help.vue';
import CargoInfo from '~/components/public/cargo/cargo-info.vue';

const usefulItems: PublicInfoGridItem[] = [
  {
    title: 'Терминалы <br> и пункты выдачи',
    link: { to: { name: 'terminals' } }
  },
  {
    title: 'Расчет срока <br>доставки',
    link: { to: { name: 'run-schedule' } }
  },
  {
    title: 'Вопросы-ответы',
    link: { to: { name: 'help' } }
  },
  {
    title: 'Необходимые документы',
    link: { to: { name: 'documents' } }
  },
]
</script>

<style scoped lang="scss">
.cargo {
  &-container {
    display: flex;
    flex-direction: column;
    gap: 110px;
    margin-top: 70px;
    margin-bottom: 110px;

    &-useful {
      :deep(.public-service-links-grid-items) {
        grid-template-columns: repeat(4, 1fr);
      }
    }

    &-contacts {
      max-width: unset;
      :deep(.contacts-departments-wrapper) {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;

        @media screen and (max-width: $pub-xs) {
          grid-template-columns: 1fr;
        }
      }
    }

    @media screen and (max-width: $pub-md) {
      gap: 90px;
      margin-top: 90px;
      margin-bottom: 90px;
    }

    @media screen and (max-width: $pub-sm) {
      gap: 70px;
      margin-top: 70px;

      &-useful {
        :deep(.public-service-links-grid-items) {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }

    @media screen and (max-width: $pub-xs) {
      gap: 50px;
      margin-top: 50px;
      margin-bottom: 50px;
    }
  }
}
</style>
